<template>
    <p v-if="isLoading" class="mt-5">Memuat...</p>
    <section v-else>
        <div class="row">
            <div class="col pl-5 mt-5 mb-3">
                <div class="row justify-content-end">
                    <div class="col">
                        <div class="row mb-1 align-items-center">
                            <div class="col-lg-3 col-md-4 col-sm-3 p-1">
                                <label class="font-weight-bold h4 mb-0 form-divider">Nama Lengkap</label>
                            </div>
                            <div class="col-auto p-1">
                                <h4 class="font-weight-medium mb-0 text-loading" v-if="student.user">{{ student.user.name }}</h4>
                            </div>
                        </div>
                        <div class="row mb-1 align-items-center">
                            <div class="col-lg-3 col-md-4 col-sm-3 p-1">
                                <label class="font-weight-bold h4 mb-0 form-divider">No. Peserta</label>
                            </div>
                            <div class="col-auto p-1">
                                <h4 class="font-weight-medium mb-0 text-loading" v-if="student.user">{{ student.identity }}</h4>
                            </div>
                        </div>
                    </div>
                    <div class="col-auto align-self-end">
                        <template v-if="roleElligibleAccess()">
                            <router-link v-bind:to="{ name: 'account/student/recommendation/index', params: {type: courseCategory.id} }" class="btn btn-outline-danger btn-sm ml-2" v-for="courseCategory in courseCategories" v-bind:key="courseCategory.id">
                                Rekomendasi Prodi {{ courseCategory.name }}
                            </router-link>
                        </template>
                        <button class="btn btn-danger btn-sm ml-2" type="button" v-on:click="print()" v-if="false">
                            Cetak Laporan Nilai
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <h3>Nilai Tryout</h3>
        <template v-if="student.image == NULL && student.branchID != 59">
            <div class="row">
                <div class="col-auto">
                    <p> Dimohon untuk mengunggah foto pada menu <a href="https://btagroup.co.id/account/student/profile">data diri</a> untuk bisa melihat nilai Tryout</p>
                    <p> Terima kasih :) </p>
                </div>
            </div>
        </template>
        <template v-if="student.branchID == 59 || student.image != NULL">
            <div class="row" v-for="tryout in tryouts" v-bind:key="tryout.id + 'isSimak'">
                <template v-if="tryout.isSimak != 1">
                    <div class="col mb-3">
                        <div class="slim-scroll scroll-x" v-dragscroll="!isMobile()">
                            <div class="row">
                                <div class="col-auto">
                                    <!-- Banner Pengumuman -->
                                    <div class="row mb-2">
                                        <div class="col">
                                            <div class="card shadow-sm border-0">
                                                <div class="card-header background-primary">
                                                    <div class="row align-items-center">
                                                        <div class="col-auto pr-0" v-if="!tryout.hasAnalysis">
                                                            <router-link v-bind:to="{name: 'account/student/tryout/view', params: {id: tryout.id}}" class="btn btn-sm btn-outline-light font-weight-light h6 mb-0">
                                                                Analisis
                                                            </router-link>
                                                        </div>
                                                        <div class="col">
                                                            <span class="h4 font-weight-bold text-white mb-0">
                                                                Pengumuman {{ tryout.name }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Grid Nilai Utama (Tryout PTN - Tanpa Kode Soal) -->
                                    <div class="row grid align-items-stretch">
                                        <template v-if="typeof tryout.tryoutGroups !== typeof undefined">
                                            <div class="col-auto d-flex flex-column mb-2">
                                                <div class="card shadow-sm border-0 h-100 d-flex flex-column">
                                                    <div class="card-header background-primary text-white px-2 py-1 header-full-height d-flex align-items-center justify-content-center">
                                                        <h4 class="mb-0 text-center">Jumlah</h4>
                                                    </div>
                                                    <div class="card-body p-2 d-flex flex-column justify-content-between flex-grow-1">
                                                        <div class="height-1 d-flex align-items-center">Benar</div>
                                                        <div class="height-1 d-flex align-items-center">Salah</div>
                                                        <div class="height-1 d-flex align-items-center font-weight-bold">Nilai</div>
                                                    </div>
                                                </div>
                                            </div>

                                            <template v-for="(tryoutGroup, index) in tryout.tryoutGroups">
                                                <template v-for="tryoutSubject in tryoutGroup.tryoutSubjects">
                                                    <div class="col-auto d-flex flex-column mb-2" v-if="isSubjectAttempted(tryoutSubject)" v-bind:key="tryoutSubject.id">
                                                        <div class="card shadow-sm border-0 h-100 d-flex flex-column">
                                                            <div class="px-2 py-1 text-center font-weight-bold text-white header-group-title d-flex align-items-center justify-content-center" v-bind:class="classStyles[index % classStyles.length]">
                                                                {{ tryoutGroup.groupSubject.name }}
                                                            </div>
                                                            <div class="card-header px-2 py-1 d-flex align-items-center justify-content-center border-top-0 header-sub-title" v-bind:class="classStyles[index % classStyles.length]">
                                                                <h4 class="mb-0 text-center width-2">{{ tryoutSubject.subject.shortname }}</h4>
                                                            </div>
                                                            <div class="card-body p-2 d-flex flex-column justify-content-between flex-grow-1">
                                                                <div class="height-1 d-flex align-items-center justify-content-center text-center">{{ tryoutSubject.subjectScores[0].correctAnswer }}</div>
                                                                <div class="height-1 d-flex align-items-center justify-content-center text-center">{{ tryoutSubject.subjectScores[0].wrongAnswer }}</div>
                                                                <div class="height-1 d-flex align-items-center justify-content-center text-center font-weight-bold text-primary">{{ formatScore(tryoutSubject.subjectScores[0].score) }}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>
                                            </template>

                                            <template v-for="(tryoutGroup, index) in tryout.tryoutGroups">
                                                <template v-if="typeof tryoutGroup.groupScores !== typeof undefined && tryoutGroup.groupScores[0]">
                                                    <div class="col-auto d-flex flex-column mb-2" v-bind:key="'score-' + index">
                                                        <div class="card shadow-sm border-0 h-100 d-flex flex-column">
                                                            <div class="card-header background-primary text-white px-2 py-1 header-full-height d-flex align-items-center justify-content-center">
                                                                <h4 class="mb-0 text-center"><i>Score TO</i></h4>
                                                            </div>
                                                            <div class="card-body p-2 d-flex align-items-center justify-content-center flex-grow-1">
                                                                <div class="text-center font-weight-bold text-primary h4 mb-0">{{ formatScore(tryoutGroup.groupScores[0].percentage) }}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-auto d-flex flex-column mb-2" v-bind:key="'rank-' + index">
                                                        <div class="card shadow-sm border-0 h-100 d-flex flex-column">
                                                            <div class="card-header background-primary text-white px-2 py-1 header-full-height d-flex align-items-center justify-content-center">
                                                                <h4 class="mb-0 text-center"><i class="fa fa-trophy"></i></h4>
                                                            </div>
                                                            <div class="card-body p-2 d-flex align-items-center justify-content-center flex-grow-1">
                                                                <h4 class="mb-0 text-center">
                                                                    <div>{{ tryoutGroup.rank }}</div>
                                                                    <div>dari</div>
                                                                    <div>{{ tryoutGroup.totalStudent }}</div>
                                                                </h4>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>
                                            </template>

                                            <div class="col-auto d-flex flex-column mb-2">
                                                <div class="card shadow-sm border-0 h-100 d-flex flex-column">
                                                    <div class="card-header background-primary text-white px-2 py-1 header-full-height d-flex align-items-center justify-content-center">
                                                        <h4 class="mb-0 text-center"><i class="fa fa-file-text-o"></i></h4>
                                                    </div>
                                                    <div class="card-body p-2 d-flex align-items-center justify-content-center flex-grow-1">
                                                        <h4 class="mb-0" v-html="note(tryout)"></h4>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>

                                        <template v-else>
                                            <div class="col-auto d-flex flex-column mb-2">
                                                <div class="card shadow-sm border-0 h-100 d-flex flex-column">
                                                    <div class="card-header background-primary text-white px-2 py-1 header-full-height d-flex align-items-center justify-content-center">
                                                        <h4 class="mb-0 text-center">Jumlah</h4>
                                                    </div>
                                                    <div class="card-body p-2 d-flex flex-column justify-content-between flex-grow-1">
                                                        <div class="height-1 d-flex align-items-center">Benar</div>
                                                        <div class="height-1 d-flex align-items-center">Salah</div>
                                                        <div class="height-1 d-flex align-items-center font-weight-bold">Nilai</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <template v-for="(tryoutSubject, index) in tryout.tryoutSubjects">
                                                <div class="col-auto mb-2" v-if="isSubjectAttempted(tryoutSubject)" v-bind:key="tryoutSubject.id">
                                                    <div class="card shadow-sm border-0 h-100 d-flex flex-column">
                                                        <div class="card-header px-2 py-2 header-full-height d-flex align-items-center justify-content-center" v-bind:class="classStyles[index % classStyles.length]">
                                                            <div class="text-center width-2">
                                                                <h4 class="mb-0">{{ tryoutSubject.subject.shortname }}</h4>
                                                            </div>
                                                        </div>
                                                        <div class="card-body p-2 d-flex flex-column justify-content-between flex-grow-1">
                                                            <div class="height-1 d-flex align-items-center justify-content-center text-center">{{ tryoutSubject.subjectScores[0].correctAnswer }}</div>
                                                            <div class="height-1 d-flex align-items-center justify-content-center text-center">{{ tryoutSubject.subjectScores[0].wrongAnswer }}</div>
                                                            <div class="height-1 d-flex align-items-center justify-content-center text-center font-weight-bold text-primary">{{ formatScore(tryoutSubject.subjectScores[0].score) }}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                            <div class="col-auto d-flex flex-column mb-2">
                                                <div class="card shadow-sm border-0 h-100 d-flex flex-column">
                                                    <div class="card-header background-primary text-white px-2 py-1 header-full-height d-flex align-items-center justify-content-center">
                                                        <h4 class="mb-0 text-center">Total Nilai</h4>
                                                    </div>
                                                    <div class="card-body p-2 d-flex align-items-center justify-content-center flex-grow-1">
                                                        <div class="font-weight-bold h4 mb-0 text-primary">{{ formatScore(tryout.totalScore) }}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-auto d-flex flex-column mb-2" v-if="tryout.hasRank">
                                                <div class="card shadow-sm border-0 h-100 d-flex flex-column">
                                                    <div class="card-header background-primary text-white px-2 py-1 header-full-height d-flex align-items-center justify-content-center">
                                                        <h4 class="mb-0 text-center"><i class="fa fa-trophy"></i></h4>
                                                    </div>
                                                    <div class="card-body p-2 d-flex align-items-center justify-content-center flex-grow-1">
                                                        <h4 class="mb-0 text-center">
                                                            <div>{{ tryout.rank }}</div>
                                                            <div>dari</div>
                                                            <div>{{ tryout.totalStudent }}</div>
                                                        </h4>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </template>
        
        <h3>Nilai Tes Evaluasi Harian</h3>
        <div class="row" v-for="tryout in tryouts" v-bind:key="tryout.id">
            <template v-if="tryout.isSimak == 1">
                <div class="col mb-3">
                    <div class="slim-scroll scroll-x" v-dragscroll="!isMobile()">
                        <div class="row">
                            <div class="col-auto">
                                <div class="row mb-2">
                                    <div class="col">
                                        <div class="card shadow-sm border-0">
                                            <div class="card-header background-primary">
                                                <div class="row align-items-center">
                                                    <div class="col-auto pr-0" v-if="!tryout.hasAnalysis">
                                                        <router-link v-bind:to="{name: 'account/student/tryout/view', params: {id: tryout.id}}" class="btn btn-sm btn-outline-light font-weight-light h6 mb-0">
                                                            Analisis
                                                        </router-link>
                                                    </div>
                                                    <div class="col">
                                                        <span class="h4 font-weight-bold text-white mb-0">
                                                            Pengumuman {{ tryout.name }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Grid Evaluasi Harian (Mengikutsertakan Kode Soal) -->
                                <div class="row grid align-items-stretch">
                                    <template v-if="typeof tryout.tryoutGroups !== typeof undefined">
                                        <div class="col-auto d-flex flex-column mb-2">
                                            <div class="card shadow-sm border-0 h-100 d-flex flex-column">
                                                <div class="card-header background-primary text-white px-2 py-1 header-full-height d-flex align-items-center justify-content-center">
                                                    <h4 class="mb-0 text-center">Jumlah</h4>
                                                </div>
                                                <div class="card-body p-2 d-flex flex-column justify-content-between flex-grow-1">
                                                    <div class="height-1 d-flex align-items-center">Benar</div>
                                                    <div class="height-1 d-flex align-items-center">Salah</div>
                                                    <div class="height-1 d-flex align-items-center font-weight-bold">Nilai</div>
                                                </div>
                                            </div>
                                        </div>
                                        <template v-for="(tryoutGroup, index) in tryout.tryoutGroups">
                                            <template v-for="tryoutSubject in tryoutGroup.tryoutSubjects">
                                                <div class="col-auto d-flex flex-column mb-2" v-if="isSubjectAttempted(tryoutSubject)" v-bind:key="tryoutSubject.id">
                                                    <div class="card shadow-sm border-0 h-100 d-flex flex-column">
                                                        <!-- Tetap Ada Kode Soal untuk Tes Evaluasi Harian -->
                                                        <div class="px-2 py-1 text-center font-weight-bold text-white header-group-title d-flex align-items-center justify-content-center" v-bind:class="classStyles[index % classStyles.length]">
                                                            {{ tryoutGroup.groupSubject.name }} ({{ tryoutGroup.code }})
                                                        </div>
                                                        <div class="card-header px-2 py-1 d-flex align-items-center justify-content-center border-top-0 header-sub-title" v-bind:class="classStyles[index % classStyles.length]">
                                                            <h4 class="mb-0 text-center width-2">{{ tryoutSubject.subject.shortname }}</h4>
                                                        </div>
                                                        <div class="card-body p-2 d-flex flex-column justify-content-between flex-grow-1">
                                                            <div class="height-1 d-flex align-items-center justify-content-center text-center">{{ tryoutSubject.subjectScores[0].correctAnswer }}</div>
                                                            <div class="height-1 d-flex align-items-center justify-content-center text-center">{{ tryoutSubject.subjectScores[0].wrongAnswer }}</div>
                                                            <div class="height-1 d-flex align-items-center justify-content-center text-center font-weight-bold text-primary">{{ formatScore(tryoutSubject.subjectScores[0].score) }}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                        </template>

                                        <template v-for="(tryoutGroup, index) in tryout.tryoutGroups">
                                            <template v-if="typeof tryoutGroup.groupScores !== typeof undefined && tryoutGroup.groupScores[0]">
                                                <div class="col-auto d-flex flex-column mb-2" v-bind:key="'score-' + index">
                                                    <div class="card shadow-sm border-0 h-100 d-flex flex-column">
                                                        <div class="card-header background-primary text-white px-2 py-1 header-full-height d-flex align-items-center justify-content-center">
                                                            <h4 class="mb-0 text-center"><i>Rataan</i><br />{{ tryoutGroup.groupSubject.name }}</h4>
                                                        </div>
                                                        <div class="card-body p-2 d-flex align-items-center justify-content-center flex-grow-1">
                                                            <div class="text-center font-weight-bold text-primary h4 mb-0">{{ formatScore(tryoutGroup.groupScores[0].percentage) }}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-auto d-flex flex-column mb-2" v-if="tryout.hasRank" v-bind:key="'rank-' + index">
                                                    <div class="card shadow-sm border-0 h-100 d-flex flex-column">
                                                        <div class="card-header background-primary text-white px-2 py-1 header-full-height d-flex align-items-center justify-content-center">
                                                            <h4 class="mb-0 text-center"><i class="fa fa-trophy"></i></h4>
                                                        </div>
                                                        <div class="card-body p-2 d-flex align-items-center justify-content-center flex-grow-1">
                                                            <h4 class="mb-0 text-center">
                                                                <div>{{ tryoutGroup.rank }}</div>
                                                                <div>dari</div>
                                                                <div>{{ tryoutGroup.totalStudent }}</div>
                                                            </h4>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                        </template>
                                        <div class="col-auto d-flex flex-column mb-2">
                                            <div class="card shadow-sm border-0 h-100 d-flex flex-column">
                                                <div class="card-header background-primary text-white px-2 py-1 header-full-height d-flex align-items-center justify-content-center">
                                                    <h4 class="mb-0 text-center"><i class="fa fa-file-text-o"></i></h4>
                                                </div>
                                                <div class="card-body p-2 d-flex align-items-center justify-content-center flex-grow-1">
                                                    <h4 class="mb-0" v-html="note(tryout)"></h4>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="col-auto d-flex flex-column mb-2">
                                            <div class="card shadow-sm border-0 h-100 d-flex flex-column">
                                                <div class="card-header background-primary text-white px-2 py-1 header-full-height d-flex align-items-center justify-content-center">
                                                    <h4 class="mb-0 text-center">Jumlah</h4>
                                                </div>
                                                <div class="card-body p-2 d-flex flex-column justify-content-between flex-grow-1">
                                                    <div class="height-1 d-flex align-items-center">Benar</div>
                                                    <div class="height-1 d-flex align-items-center">Salah</div>
                                                    <div class="height-1 d-flex align-items-center font-weight-bold">Nilai</div>
                                                </div>
                                            </div>
                                        </div>
                                        <template v-for="(tryoutSubject, index) in tryout.tryoutSubjects">
                                            <div class="col-auto mb-2" v-if="isSubjectAttempted(tryoutSubject)" v-bind:key="tryoutSubject.id">
                                                <div class="card shadow-sm border-0 h-100 d-flex flex-column">
                                                    <div class="card-header px-2 py-2 header-full-height d-flex align-items-center justify-content-center" v-bind:class="classStyles[index % classStyles.length]">
                                                        <div class="text-center width-2">
                                                            <h4 class="mb-0">{{ tryoutSubject.subject.shortname }}</h4>
                                                            <h4 class="mb-0">({{ tryoutSubject.code }})</h4>
                                                        </div>
                                                    </div>
                                                    <div class="card-body p-2 d-flex flex-column justify-content-between flex-grow-1">
                                                        <div class="height-1 d-flex align-items-center justify-content-center text-center">{{ tryoutSubject.subjectScores[0].correctAnswer }}</div>
                                                        <div class="height-1 d-flex align-items-center justify-content-center text-center">{{ tryoutSubject.subjectScores[0].wrongAnswer }}</div>
                                                        <div class="height-1 d-flex align-items-center justify-content-center text-center font-weight-bold text-primary">{{ formatScore(tryoutSubject.subjectScores[0].score) }}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                        <div class="col-auto d-flex flex-column mb-2">
                                            <div class="card shadow-sm border-0 h-100 d-flex flex-column">
                                                <div class="card-header background-primary text-white px-2 py-1 header-full-height d-flex align-items-center justify-content-center">
                                                    <h4 class="mb-0 text-center">Total Nilai</h4>
                                                </div>
                                                <div class="card-body p-2 d-flex align-items-center justify-content-center flex-grow-1">
                                                    <div class="font-weight-bold h4 mb-0 text-primary">{{ formatScore(tryout.totalScore) }}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-auto d-flex flex-column mb-2" v-if="tryout.hasRank">
                                            <div class="card shadow-sm border-0 h-100 d-flex flex-column">
                                                <div class="card-header background-primary text-white px-2 py-1 header-full-height d-flex align-items-center justify-content-center">
                                                    <h4 class="mb-0 text-center"><i class="fa fa-trophy"></i></h4>
                                                </div>
                                                <div class="card-body p-2 d-flex align-items-center justify-content-center flex-grow-1">
                                                    <h4 class="mb-0 text-center">
                                                        <div>{{ tryout.rank }}</div>
                                                        <div>dari</div>
                                                        <div>{{ tryout.totalStudent }}</div>
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
        
        <div class="row">
            <div class="col text-center mt-5">
                <Adsense v-bind:data-ad-client="googleAdsClientKey" data-ad-slot="6426122373"></Adsense>
            </div>
        </div>
    </section>
</template>

<script>
    import { mapState } from 'vuex';
    import { dragscroll } from 'vue-dragscroll';

    export default {
        name: 'AccountStudentScore',
        directives: { dragscroll },
        computed: mapState(['profile']),
        data() {
            return {
                isLoading: false,
                student: {user: {}},
                tryouts: [],
                courseCategories: [],
                classStyles: ['bg-warning', 'bg-success', 'bg-info text-white'],
                googleAdsClientKey: process.env.GOOGLE_ADS_CLIENT
            };
        },
        methods: {
            print() { alert('Not Implemented'); },
            analize(tryout) { alert('Not Implemented'); },
            roleElligibleAccess() {
                return this.profile.isStudent && this.profile.student.btaGrade.level >= 12;
            },
            isMobile() {
                return 'ontouchstart' in window || navigator.msMaxTouchPoints;
            },
            isSubjectAttempted(tryoutSubject) {
                if (!tryoutSubject.subjectScores || !tryoutSubject.subjectScores.length) {
                    return false;
                }
                const scoreData = tryoutSubject.subjectScores[0];
                return scoreData.correctAnswer > 0 || scoreData.wrongAnswer > 0 || scoreData.score > 0;
            },
            formatScore(val) {
                if (val === null || val === undefined || isNaN(val)) return '0.00';
                const num = Number(val);
                return Number.isInteger(num) ? num.toString() : num.toFixed(2);
            },
            note(tryout) {
                let notes = [];
                if (typeof tryout.tryoutGroups !== typeof undefined && tryout.tryoutGroups.length) {
                    notes = tryout.tryoutGroups.map(tryoutGroup => tryoutGroup.groupScores.length ? (tryoutGroup.groupScores[0].note || '') : '');
                } else {
                    notes = tryout.tryoutSubjects.map(tryoutSubject => tryoutSubject.subjectScores.length ? (tryoutSubject.subjectScores[0].note || '') : '');
                }
                return notes.join('<br />');
            }
        },
        created() {
            this.isLoading = true;
            this.axios.all([
                this.axios.get(process.env.API_URL + '/student/scores'),
                this.axios.get(process.env.API_URL + '/course-category')
            ]).then(this.axios.spread(function (responseScore, responseCourseCategory) {
                this.student = responseScore.data.data.student;
                this.tryouts = responseScore.data.data.tryouts;
                this.courseCategories = responseCourseCategory.data.data;
                this.isLoading = false;
            }.bind(this)));

            document.title = 'Laporan Nilai - ' + process.env.APP_NAME;
        }
    }
</script>

<style scoped>
    .width-1 { min-width: 2rem; }
    .width-2 { min-width: 4.5rem; }
    .height-1 { 
        min-height: 2.2rem; 
    }
    
    .header-full-height {
        height: 5rem;
    }

    .header-group-title {
        height: 2.2rem;
        font-size: 0.85rem;
        border-top-left-radius: 0.25rem;
        border-top-right-radius: 0.25rem;
    }

    .header-sub-title {
        height: 2.8rem;
    }

    .card {
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/components/account/student/Score.vue